<!-- <div class="container">
  <div class="row">
    <div class="col-12 alignCenter">
      <h4>{{confirmationData.title}}</h4>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="row message-div">
    <div class="col-12 alignCenter">
      {{confirmationData.confirmMessage}}
    </div>
  </div>
  <div class="row message-div" *ngIf="data.displayComment">
    <div class="col-12 alignCenter">
      <mat-form-field style="width: 100%">
        <mat-label>{{data.requiredComment ? 'Confirm Name' : 'Comments'}}</mat-label>
        <input matInput type="text" #commentsInput id="commentsInput" name="commentsInput" [(ngModel)]="this.comments"
          [value]="this.comments">
      </mat-form-field>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="actions-div row" [ngClass]="{'centered': !confirmationData.cancelLabel}">
    <div class="d-flex align-items-center w-100" [ngClass]="{'justify-content-center': !confirmationData.cancelLabel, 'justify-content-end': confirmationData.cancelLabel}">
      <button mat-raised-button class="yesButton" (click)="close(true)"
        *ngIf="!isLoading" [disabled]="data.requiredComment && comments !== data.requiredComment">{{confirmationData.confirmLabel}}</button>
      <mat-spinner *ngIf="isLoading" [diameter]="20"></mat-spinner>
      <button *ngIf="confirmationData.cancelLabel" mat-raised-button (click)="close(false)"
        class="cancel-btn ms-2">{{confirmationData.cancelLabel}}</button>
    </div>
  </div>
</div> -->  


<h2 mat-dialog-title>{{confirmationData.title}}</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="col-12 alignCenter ls-1">
   {{confirmationData.confirmMessage}}
  </div>
  <div class="row message-div" *ngIf="data.displayComment">
    <div class="col-12 alignCenter">
      <mat-form-field style="width: 100%">
        <mat-label>{{data.requiredComment ? 'Confirm Name' : 'Comments'}}</mat-label>
        <input matInput type="text" #commentsInput id="commentsInput" name="commentsInput" [(ngModel)]="this.comments"
          [value]="this.comments">
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions class="d-flex justify-content-end">
  <button [ngClass]="confirmationData.title=='Add Chemical'?'confirm-button me-2':'delete-button me-2'" (click)="close(true)"
    *ngIf="!isLoading" [disabled]="data.requiredComment && comments !== data.requiredComment">{{confirmationData.confirmLabel}}</button>
  <mat-spinner *ngIf="isLoading" [diameter]="20"></mat-spinner>
  <button *ngIf="!this.data.isWarning"  (click)="close(false)"
    class="custom-button cancel-button"><span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>{{confirmationData.cancelLabel}}</button>
</mat-dialog-actions>